/* ————— Real brand assets: the store's own Logo Suite files on the Shopify CDN (evergreen colorway, variant 06) ————— */
const LOGO="https://cdn.shopify.com/s/files/1/0711/0285/7449/files/BB_RGB_LOGO_PRIMARY_TRANSPARENT_FULL_LOGO_06.png?v=1732114963&width=520";
const CREST="https://cdn.shopify.com/s/files/1/0711/0285/7449/files/BB_RGB_LOGO_SECONDARY_TRANSPARENT_CIRCLE_06.png?v=1732126665&width=480";
const MONOGRAM="https://cdn.shopify.com/s/files/1/0711/0285/7449/files/BB_RGB_LOGO_SECONDARY_TRANSPARENT_MONOGRAM_06.png?v=1732126665&width=240";
/* Opening hero: Virginia's own product photograph, hosted by her in Shopify
   Files (Lifestyle_B_B.png, uploaded July 22 2026). */
const HERO="https://cdn.shopify.com/s/files/1/0711/0285/7449/files/Lifestyle_B_B.png?v=1784752818";

/* ————— Live products (handles verified read-only against the store, July 22 2026) ————— */
/* Registry, bench copy, questions, and all routing now live in
   the-consultation-engine.js: one source of truth, shared verbatim with
   the-consultation-routing-grid.html. */

/* ————— State ————— */
const stage=document.getElementById('stage');
const announcer=document.getElementById('announcer');
const reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
let step=-1;
let answers=QUESTIONS.map(()=>[]);

const corners=`<i class="corner tl"></i><i class="corner tr"></i><i class="corner bl"></i><i class="corner br"></i>`;
const logoTag=`<img class="logo" src="${LOGO}" alt="Butter &amp; Blush Beauty Co.">`;
const crestTag=`<img class="crest" src="${CREST}" alt="Butter &amp; Blush crest">`;
const footTag=`
  <footer class="plate-foot">
    <img class="monogram" src="${MONOGRAM}" alt="" aria-hidden="true">
    <p class="brandline">Butter &amp; Blush Beauty Co.<small>Formulated with intention · Miami · Est. 2024</small></p>
  </footer>`;

function prodTile(p,roman){
  return `<div class="ptile">
    <div class="pframe">
      <img src="${p.img}" alt="${p.n}" loading="lazy"
        onerror="this.parentElement.classList.add('img-missing')">
      <div class="img-missing-note"><img src="${MONOGRAM}" alt=""><span>image unavailable</span></div>
    </div>
    ${roman?`<span class="roman">${roman}</span>`:''}
  </div>`;
}
/* Variant IDs resolved once from the 19 live product handles (July 22, 2026).
   This mapping lives beside the registry and never inside the routing logic. */
const VARIANTS={
  superfruit:47952025125097, frangipani:47952027648233, splendid:47951998025961,
  petals:47951966929129, marinelumina:48294358941929, swiss:47951973482729,
  alpine:50039086645481, orchid:47946955686121, luscious:47951988162793,
  illume:47952009691369, magnolia:47951994650857, moonlit:47951982756073,
  mens:47952016605417, sealavender:48937844310249, keys:47952013787369,
  hemp:47953991106793, miracle:47952002187497, clever:47952007233769,
  erase:47952004710633
};
function addRitual(b,k){
  const v=VARIANTS[k];
  if(!v){return;}
  b.disabled=true; b.textContent='Adding\u2026';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
    body:JSON.stringify({items:[{id:v,quantity:1}]})})
    .then(r=>{if(!r.ok)throw new Error('cart');
      b.classList.add('added'); b.textContent='Added to your ritual \u2713';})
    .catch(()=>{b.disabled=false; b.textContent='Add to Ritual';});
}
function sealTag(roman){
  return `<div class="seal" aria-hidden="true">
    <img src="${MONOGRAM}" alt="">
    ${roman?`<span class="roman">${roman}</span>`:''}
  </div>`;
}

function houseHead(withThread){
  let h=`<div class="house-head">${logoTag}<hr class="house-rule"><p class="eyebrow">The Consultation</p>`;
  if(withThread){
    const pct=((step+1)/QUESTIONS.length)*100;
    let marks='';for(let i=0;i<=QUESTIONS.length;i++)marks+='<i></i>';
    h+=`<div class="thread-wrap" aria-hidden="true">
      <div class="thread-marks">${marks}</div>
      <div class="thread-track"></div>
      <div class="thread-fill" style="width:${pct}%"></div>
      <div class="thread-dot" style="left:${pct}%"></div>
    </div>`;
  }
  h+=`</div>`;
  return h;
}

function transition(render){
  if(reduced){stage.innerHTML='';render();window.scrollTo(0,0);return;}
  stage.classList.add('fading');
  setTimeout(()=>{stage.innerHTML='';render();stage.classList.remove('fading');window.scrollTo(0,0);},250);
}

/* ————— Screens ————— */
function showThreshold(){
  step=-1;
  transition(()=>{
    stage.innerHTML=`
    <div class="room"><div class="plate threshold">${corners}
      ${houseHead(false)}
      <div class="split">
        <div>
          <h1>What are we creating for your skin today?</h1>
          <p class="lede">Every remarkable ritual begins with understanding.<br><br>
          Answer seven thoughtful questions and we&rsquo;ll compose a Butter &amp; Blush ritual
          designed around what your skin is asking for today.<br><br>
          Each recommendation is chosen with intention: freshly made, naturally advanced,
          and seriously effective. Nothing unnecessary. Nothing included by chance.<br><br>
          Because extraordinary skincare isn&rsquo;t about using more.
          <em>It&rsquo;s about using exactly what belongs.</em></p>
          <div class="begin-row">
            <button class="btn" onclick="showQuestion(0)">Begin the Consultation</button>
            <span class="begin-note">Approximately 2 minutes</span>
          </div>
        </div>
        <figure>
          <div class="hero-frame">
            <img class="hero-img" src="${HERO}"
              alt="Butter &amp; Blush skincare: the micellar gel, the frangipani cleanser, and the balance complex resting on cream towels">
          </div>
          <figcaption class="hero-cap">Every ritual begins with a single beautiful choice.</figcaption>
        </figure>
      </div>
      ${footTag}
    </div></div>`;
    announcer.textContent="The Consultation. What are we creating for your skin today?";
  });
}

function showQuestion(i){
  step=i;
  const Q=QUESTIONS[i];
  transition(()=>{
    const sel=answers[i];
    const btns=Q.a.map((t,j)=>`<button class="answer" role="${Q.multi?'checkbox':'radio'}" aria-pressed="${sel.includes(j)}" onclick="pick(${i},${j})">${t}</button>`).join('');
    stage.innerHTML=`
    <div class="room"><div class="plate">${corners}
      ${houseHead(true)}
      <p class="qnum">Question ${ROMAN[i]} · of ${ROMAN[QUESTIONS.length-1]}</p>
      <h1 class="qtext">${Q.q}</h1>
      ${Q.h?`<p class="qhelper">${Q.h}</p>`:''}
      ${Q.hint?`<p class="qhint">${Q.hint}</p>`:''}
      <div class="answers">${btns}</div>
      <div class="nav-row">
        <button class="linklike" onclick="${i===0?'showThreshold()':'showQuestion('+(i-1)+')'}">&larr; back</button>
        <div>
          ${Q.skippable?`<button class="linklike" onclick="advance(${i},true)">skip this one</button>`:''}
          <button class="btn small" id="continue" ${sel.length? '':'disabled'} onclick="advance(${i})">Continue</button>
        </div>
      </div>
      ${footTag}
    </div></div>`;
    announcer.textContent=`Question ${i+1} of ${QUESTIONS.length}. ${Q.q}`;
  });
}

function pick(i,j){
  const Q=QUESTIONS[i];
  if(Q.multi){
    if(Q.exclusive===j){answers[i]=answers[i].includes(j)?[]:[j];}
    else{
      answers[i]=answers[i].filter(x=>x!==Q.exclusive);
      if(answers[i].includes(j))answers[i]=answers[i].filter(x=>x!==j);
      else if(answers[i].length<(Q.max||99))answers[i].push(j);
    }
  }else{answers[i]=[j];}
  document.querySelectorAll('.answer').forEach((b,k)=>b.setAttribute('aria-pressed',answers[i].includes(k)));
  const c=document.getElementById('continue');
  if(c)c.disabled=!answers[i].length;
  if(!Q.multi && answers[i].length){setTimeout(()=>advance(i),reduced?0:260);}
}

